module.exports = __webpack_public_path__ + "static/img/ranking-pergunta-adicional.6738461.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ranking-pergunta-adicional.png
// module id = 7BXu
// module chunks = 1